import { render, staticRenderFns } from "./priceDistro.vue?vue&type=template&id=7a036377&scoped=true"
import script from "./priceDistro.vue?vue&type=script&lang=js"
export * from "./priceDistro.vue?vue&type=script&lang=js"
import style0 from "./priceDistro.vue?vue&type=style&index=0&id=7a036377&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a036377",
  null
  
)

export default component.exports